import { createAction } from "redux-actions";

import {
  GET_CLIENT_PROFILE_ENTRIES_COUNT,
  SET_CLIENT_PROFILE_ENTRY_SEARCH_FILTERS,
  SET_CLIENT_PROFILE_ENTRY_CURRENT_PAGE,
  GET_CLIENT_PROFILE_ENTRIES,
  SET_ITEMS_PER_PAGE_CLIENT_PROFILE,
  SET_NO_ENTRIES_MESSAGE_CLIENT_PROFILE,
} from "../../types";
import createAsyncActions from "../../../../utilities/createAsyncActions";

export const {
  getClientProfileEntries,
  getClientProfileEntriesPending,
  getClientProfileEntriesFulfilled,
  getClientProfileEntriesRejected,
} = createAsyncActions(GET_CLIENT_PROFILE_ENTRIES, "getClientProfileEntries");

export const {
  getClientProfileEntriesCount,
  getClientProfileEntriesCountPending,
  getClientProfileEntriesCountFulfilled,
  getClientProfileEntriesCountRejected,
} = createAsyncActions(
  GET_CLIENT_PROFILE_ENTRIES_COUNT,
  "getClientProfileEntriesCount"
);

export const setSearchFilters = createAction(
  SET_CLIENT_PROFILE_ENTRY_SEARCH_FILTERS
);
export const setCurrentPage = createAction(
  SET_CLIENT_PROFILE_ENTRY_CURRENT_PAGE
);
export const setItemsPerPage = createAction(SET_ITEMS_PER_PAGE_CLIENT_PROFILE);

export const setNoEntriesMessage = createAction(
  SET_NO_ENTRIES_MESSAGE_CLIENT_PROFILE
);



// WEBPACK FOOTER //
// ./src/features/client-profile/actions/getActions/getClientProfileEntriesActions.js